import { io } from "socket.io-client";

const socket = io(
    process.env.REACT_APP_SOCKET_URL ||
        "https://sharontelematics.org",
    {
        path: "/socket.io",
        transports: ["websocket", "polling"],
        withCredentials: true,
    }
);

socket.on("connect", () => {
    console.log("✅ SOCKET CONNECTED:", socket.id);
});

socket.on("connect_error", (err) => {
    console.log("❌ SOCKET ERROR:", err.message);
});

export default socket;